<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    let LoadingEle = document.getElementById("Loading");
    if (LoadingEle) {
      document.body.removeChild(LoadingEle);
    }
  }
};
</script>

<style lang="scss">
@import "./assets/scss/variables.scss";
.schedule-date-select {
  .el-date-table td.disabled div {
    background-color: rgba(255, 255, 255, 0.1);
  }
}
.month-select {
  .el-date-picker__header--bordered {
    border-bottom: 0;
  }
  .el-picker-panel__icon-btn {
    color: #606266;
  }
}
body {
  min-width: 1280px;
  .time-select-item:hover {
    background: none;
  }
  .el-button--default {
    background: none;
    border: 1px solid #35383f;
    &:hover {
      background: none;
    }
  }
  .el-select-dropdown__item {
    background: none;
    color: $normalColor;
    &.hover {
      background: none;
    }
  }
  .el-popper[x-placement^="top"] .popper__arrow {
    border-top-color: #a8acb7;
    &::after {
      border-top-color: #fff;
    }
  }
  .el-popper[x-placement^="bottom"] .popper__arrow {
    border-bottom-color: #a8acb7;
    &::after {
      border-bottom-color: #fff;
    }
  }
  .el-select-dropdown {
    background: #fff !important;
    border-color: #a8acb7 !important;
  }
}

.el-popover {
   // 按钮配置
   .el-button {
    &.el-button--primary {
      &.is-plain:hover {
        color: #308AD9;
        border-color: #c1dcf4;
        background-color: #eaf3fb;
      }
    }
  }
}

#app {
  .el-input__inner,
  .el-textarea__inner {
    background: none;
    border: 1px solid $borderColor;
  }
  // 表格配置
  .el-table {
    background: none;
    &::before {
      height: 0;
    }
    tr,
    th,
    td {
      background: none;
      border: none;
    }
  }
  // 按钮配置
  .el-button {
    &.el-button--primary {
      background-color: $activeBgColor;
      border-color: $activeBgColor;
      &:hover {
        color: #308AD9;
        border-color: #c1dcf4;
        background-color: #eaf3fb;
      }
    }
    &.el-button--default {
      &:hover {
        border-color: $activeBgColor;
        color: $activeBgColor;
      }
    }
  }
  // 数字输入框的上下箭头隐藏
  /* 针对Chrome, Safari, Opera等浏览器 */
  input::-webkit-inner-spin-button,
  input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* 针对Firefox浏览器 */
  input[type="number"] {
    -moz-appearance: textfield;
  }
}
</style>
